const SUPPORTED_DOCUMENT_EXTENSIONS = new Set(['pdf', 'png', 'jpg', 'jpeg', 'tiff']);

const MIME_TYPE_TO_EXTENSION: Record<string, string> = {
  'application/pdf': 'pdf',
  'image/jpg': 'jpg',
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/tif': 'tiff',
  'image/tiff': 'tiff'
};

export function getDocumentFileExtension(file: File): string {
  const extension = file.name.split('.').pop()?.toLowerCase();

  if (extension) {
    if (extension === 'tif') {
      return 'tiff';
    }

    if (SUPPORTED_DOCUMENT_EXTENSIONS.has(extension)) {
      return extension;
    }
  }

  return MIME_TYPE_TO_EXTENSION[file.type.toLowerCase()] || 'png';
}
